import React, { useState } from "react";
import "../Culture/Culture.css";
import bgculture from "../../../ReactKaamvalaWebsite/assets/image/culture_sec_1st.webp";
import culture from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/culture_sec_2nd.webp";
import handshake from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/handshake-culture.svg";
import shieldCulture from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/shield-culture.svg";
import smile from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/smiley-emoji-culture.svg";
import lightbulb from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/light-bulb-culture.svg";
import officeimage from "../../../ReactKaamvalaWebsite/assets/image/officeimage.webp";
import { useNavigate } from "react-router-dom";
const Culture = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    country: "",
    message: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
  };
  return (
    <>
      <section id="culture_bgimg">
        <div className="container culture">
          <h1>Our Culture</h1>
          <p>
            At {""}
            <b>Kaamvala</b>
            ,our culture is built on a foundation of innovation, collaboration,
            and integrity. We foster an inclusive environment where diverse
            ideas thrive, and excellence is not just an aspiration but a
            standard. Join us and be part of a community where continuous
            learning and sustainability drive our mission to empower individuals
            and businesses to achieve their full potential.
          </p>
          <button
            type="button"
            className="button-culture"
            onClick={() => navigate("/company/login")}
          >
            Join Our Team!
          </button>
        </div>
      </section>
      <section className="culture_second_section">
        <div className="container pt-5 culture_second_second_container">
          <div className="culture_section_heading_common">
            <h2 className="text-center">Who We Are</h2>
          </div>
          <div className="culture_second_section_img_content py-4">
            <div className="culture_pages_img">
              <img
                src={culture}
                width="600px"
                height="415px"
                alt="web and app development"
                loading="lazy"
              />
            </div>
            <div className="who_we_culture">
              <p>
                At Kaamvala, we believe that our people are our greatest asset.
                We are a diverse team of passionate and innovative individuals
                who are committed to making a positive impact in everything we
                do. Our mission is to "empower individuals and businesses to
                achieve their full potential," and we strive to achieve this by
                fostering a culture of collaboration, creativity, and continuous
                learning.
              </p>
              <p>
                Our vision is to "be the leading force in driving technological
                advancements and creating sustainable solutions," guiding us as
                we navigate the ever-changing landscape of our industry. We are
                driven by our core values of innovation, collaboration,
                integrity, and excellence, which shape our daily interactions
                and decisions.
              </p>
              <p>
                Whether we are working on cutting-edge projects, brainstorming
                new ideas, or simply enjoying each other’s company, we are
                united by a shared purpose and a commitment to excellence. Join
                us on this exciting journey, and be a part of a team that is
                shaping the future.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container my-5">
          <div className="culture_section_heading_common core_values_culture pb-5">
            <h2 className="text-center">Our Core Values</h2>
          </div>
          <div className="row pt-3">
            <div className="col-md-6 col-lg-3 justify-content-center mt-5 mt-lg-0 mx-auto d-flex">
              <div className="card-culture">
                <div className="card_culture_upper_img">
                  <img
                    src={lightbulb}
                    alt="web and app development"
                    width="68px"
                    height="68px"
                  />
                </div>
                <div
                  className="card-body-innvation"
                  style={{
                    width: "250px",
                    height: "300px",
                  }}
                >
                  <h5 className="card-title">Innovation</h5>
                  <p className="box-para-1">
                    We encourage creative thinking and embrace new ideas.
                    Innovation is at the heart of our work, driving us to
                    continuously improve and push the boundaries of what’s
                    possible.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-3 justify-content-center mt-5 mt-lg-0 mx-auto d-flex">
              <div className="card-culture">
                <div className="card_culture_upper_img">
                  <img
                    src={shieldCulture}
                    alt="web and app development"
                    width="68px"
                    height="68px"
                  />
                </div>
                <div
                  className="card-body-integrity"
                  style={{
                    width: "250px",
                    height: "300px",
                  }}
                >
                  <h5 className="card-title">Integrity</h5>
                  <p className="box-para-1">
                    We act with honesty and integrity in all our dealings. Our
                    commitment to ethical practices builds trust and strengthens
                    our relationships with clients, partners, and each other.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 justify-content-center mt-5 mt-lg-0 mx-auto d-flex">
              <div className="card-culture">
                <div className="card_culture_upper_img">
                  <img
                    src={handshake}
                    alt="web and app development"
                    width="68px"
                    height="68px"
                  />
                </div>
                <div
                  className="card-body-collaboration"
                  style={{
                    width: "250px",
                    height: "300px",
                  }}
                >
                  <h5 className="card-title">Collaboration</h5>
                  <p className="box-para-1">
                    Teamwork is at the core of our success. We believe that
                    collaboration brings out the best in us, fostering a
                    supportive environment where diverse perspectives lead to
                    better solutions.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 justify-content-center mt-5 mt-lg-0 mx-auto d-flex">
              <div className="card-culture">
                <div className="card_culture_upper_img">
                  <img
                    src={smile}
                    alt="web and app development"
                    width="68px"
                    height="68px"
                  />
                </div>
                <div
                  className="card-body-excellence"
                  style={{
                    width: "250px",
                    height: "300px",
                  }}
                >
                  <h5 className="card-title">Excellence</h5>
                  <p className="box-para-1">
                    We strive for excellence in every task we undertake. Our
                    dedication to quality and continuous improvement ensures
                    that we deliver the best possible outcomes for our clients
                    and our team.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="culture_second_section">
        <div className="container py-5 py-md-1 culture_second_container">
          <div className="culture_section_heading_common">
            <h2 className="text-center">Office Culture at Kaamvala</h2>
          </div>
          <div className="culture_fourth_section_img_content py-4">
            <div className="culture_page_img_office">
              <img
                src={officeimage}
                alt="web and app development"
                width="100%"
                height="auto"
              />
            </div>
            <div className="who_we_culture office_cul">
              <p>
                At Kaamvala, we believe that our office culture is the
                foundation of our success. Our workplace is more than just a
                place to work; it's a community where employees feel valued,
                supported, and inspired to achieve their best. Here’s what you
                can expect when you join our team:
              </p>
              <p>
                <b>Supportive Atmosphere:</b>Our office is a supportive and
                friendly environment. We foster a positive atmosphere where
                employees feel comfortable seeking help and offering assistance.
              </p>
              <p>
                <b>Creative Spaces:</b>Our office is designed with creativity in
                mind. Open workspaces, quiet zones, and breakout areas provide
                the perfect environment for brainstorming and collaboration.
              </p>
              <button
                type="button"
                className="button-culture"
                onClick={() => navigate("/company/login ")}
              >
                Join Our Team !
              </button>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="culture_contact_section_start">
          <div className="container contact_section_culture">
            <div className="contact_content_culture">
              <h3>
                Have something in mind?
                <br />
                Let's discuss!
              </h3>
              <h6>Fill the form, have a great day!</h6>
            </div>
            <div className="contact_frm_culture">
              <form action="">
                <div className="form-card3">
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-12 form-group">
                      <p>
                        <span>
                          <input
                            className="cul_cont_cmn"
                            size="40"
                            maxlength="400"
                            required
                            placeholder="Your Name"
                            type="text"
                            name=""
                            id=""
                          />
                        </span>
                      </p>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12 form-group">
                      <p>
                        <span>
                          <input
                            className="cul_cont_cmn"
                            size="40"
                            maxlength="400"
                            required
                            placeholder=" Your Email"
                            type="text"
                            name=""
                            id=""
                          />
                        </span>
                      </p>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12 form-group">
                      <p>
                        <span>
                          <input
                            className="cul_cont_cmn dd_cul_frm"
                            size="40"
                            maxlength="400"
                            required
                            placeholder="Phone no."
                            type="text"
                            name=""
                            id=""
                          />
                        </span>
                      </p>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12 form-group">
                      <select
                        id="mySelect"
                        name="country"
                        className="dd_cul_frm cul_cont_cmn"
                        value={formData.country}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Country</option>
                        <option className="bg-option" value="India">
                          India
                        </option>
                        <option className="bg-option" value="Pakistan">
                          Pakistan
                        </option>
                        <option className="bg-option" value="Nepal">
                          Nepal
                        </option>
                      </select>
                    </div>

                    <div className="form-card3">
                      <div className="row">
                        <div className="col-12 form-group">
                          <textarea
                            name="message"
                            id="myTextarea"
                            className="msg_cul_frm cul_cont_cmn text-area"
                            placeholder="Message"
                            value={formData.message}
                            onChange={handleChange}
                            rows="4"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <button className="cul_sub_frm_btn">Submit</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Culture;
